var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.utils = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.durationToMinutes = _exports.parseIframeUrl = void 0;

  var parseIframeUrl = function parseIframeUrl(iframe) {
    var matches = /src="([^"]+)"/.exec(iframe);
    return matches[1];
  };

  _exports.parseIframeUrl = parseIframeUrl;

  var durationToMinutes = function durationToMinutes(duration) {
    return duration > 0 ? Math.ceil(duration / 60) : 0;
  };

  _exports.durationToMinutes = durationToMinutes;
});